module.exports = __webpack_public_path__ + "static/media/04-2.f98785e1.webp";